import { button } from '../../../../../component/component'

export default function(o,c){

  var next =
    button(null,'fi-next')

  return next

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/next/next.js